import styled from "styled-components";

import {
  MAP_VEHICLE_TRACKING_POPUP_CLASS,
  MapLibreMapHost,
} from "@ryde/controls";
import {
  COURSE_CODE_MARKER_HEIGHT_PX,
  COURSE_CODE_MARKER_WIDTH_PX,
} from "@ryde/shared";
import { ScreenDepth } from "@ryde/theme";

import { MAPLIBRE_VEHICLE_CAR_SIZE_PX } from "./maplibre-vehicle-car-marker.constants";

/**
 * The shared `MapLibreMapHost` plus the route map's own chrome: station dots, the vehicle marker and
 * incident pins. Everything generic (canvas, HTML markers, popup styling — including the trail-point
 * tooltip's compact card) comes from the host's own `StyledMapLibreMapHost`.
 *
 * The station-popup rule below uses `&&` so it beats the host's generic non-vehicle popup rule, which
 * has the same specificity — before the split both lived in one block and won on source order alone.
 */
export const StyledRouteBlockMapLibreHost = styled(MapLibreMapHost)`
  & .maplibre-vehicle-marker {
    cursor: pointer;
    position: relative;
    overflow: visible;
    line-height: 0;
    flex-shrink: 0;
  }

  & .maplibre-vehicle-marker--car {
    box-sizing: border-box;
    width: ${MAPLIBRE_VEHICLE_CAR_SIZE_PX}px;
    height: ${MAPLIBRE_VEHICLE_CAR_SIZE_PX}px;
  }

  & .maplibre-vehicle-marker .map-marker-icon--course-code {
    display: block;
    box-sizing: border-box;
    width: ${COURSE_CODE_MARKER_WIDTH_PX}px !important;
    height: ${COURSE_CODE_MARKER_HEIGHT_PX}px !important;
    border-radius: 0;
    overflow: visible;
    transform: none !important;
  }

  & .maplibre-incident-marker {
    cursor: pointer;
  }

  /*
   * Station info popup: rounded card + tip. Sits above the trail-point tooltip
   * (Leaflet popupPane > tooltipPane) so a hovered GPS point never covers it.
   */
  & .maplibregl-popup.maplibre-station-info-popup {
    z-index: ${ScreenDepth.MAP_MAPLIBRE_STATION_POPUP};
  }

  & .maplibregl-popup.${MAP_VEHICLE_TRACKING_POPUP_CLASS} {
    z-index: ${ScreenDepth.MAP_VEHICLE_TRACKING_POPUP};
  }

  && .maplibregl-popup.maplibre-station-info-popup .maplibregl-popup-content {
    /* Extra inline-end padding leaves room for the close button (X). */
    padding: 13px 32px 13px 20px;
    border-radius: 12px;
    box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
  }
`;
